import PropTypes from 'prop-types';

import MuiGrid from '../../../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../../../shared/icons';
import GridOptions from './GridOptions';
import { useTranslation } from 'react-i18next';

const GridProvider = ({ data, handleOpenDialog, getEditData }) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: '',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDialog(e.id)}
          getEditData={() => getEditData(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'naziv', headerName: 'Naziv', width: 300 },
    { field: 'opis', headerName: 'Opis', width: 350 },
    { field: 'partNumber', headerName: t('partNumber'), width: 150 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
  getEditData: PropTypes.func.isRequired,
};

export default GridProvider;
